// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_sx-0";